import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core";
import useInterval from "../hooks/useInterval";
import { useAuth } from "../contexts/authContext";
import layoutConstants from "../constants/layoutConstants";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const useStyles = makeStyles(() => ({
  googleLoginButton: {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

function GoogleLoginButton() {
  const classes = useStyles();
  const { onGoogleLoginSuccess } = useAuth();
  const googleButtonContainerRef = useRef(null);
  const [isGoogleLoading, setIsGoogleLoading] = useState(true);

  useInterval({
    callback: () => {
      if (typeof window !== "undefined" && window.google)
        setIsGoogleLoading(false);
    },
    delay: isGoogleLoading ? 100 : null,
  });

  useEffect(() => {
    window.google?.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      auto_select: true,
      callback: (credentialResponse) => {
        if (!credentialResponse.clientId || !credentialResponse.credential)
          return;

        onGoogleLoginSuccess(credentialResponse.credential);
      },
    });

    window.google?.accounts.id.renderButton(googleButtonContainerRef.current, {
      size: "large",
      width: layoutConstants.loginFormWidth,
    });

    return () => {
      window.google?.accounts.id.cancel();
    };
  }, [isGoogleLoading]);

  return (
    <div className={classes.googleLoginButton} ref={googleButtonContainerRef} />
  );
}

export default GoogleLoginButton;
